import { render, staticRenderFns } from "./pagePart4.vue?vue&type=template&id=760409f8&scoped=true"
import script from "./pagePart4.vue?vue&type=script&lang=js"
export * from "./pagePart4.vue?vue&type=script&lang=js"
import style0 from "./pagePart4.vue?vue&type=style&index=0&id=760409f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760409f8",
  null
  
)

export default component.exports